import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkCreateOrgStructureAssignment as apiFn } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useBulkCreateOrgStructureAssignment() {
    const navigate = useNavigate();
    const qc = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: bulkCreate, isPending, error } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => {
            enqueueSnackbar(r.message, { variant: "success" });
            qc.invalidateQueries({ queryKey: ["orgStructureAssignments"] });
            navigate('/org-structure-assignments');
        },
        onError: (err) => {
            enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" });
        },
    });

    return { bulkCreate, isPending, error };
}
